var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.7L18 11.7M18 11.7L21 14.7M18 11.7V17.7M21 6.69995H1M21 8.69995V4.89995C21 3.77985 21 3.2198 20.782 2.79197C20.5903 2.41565 20.2843 2.10969 19.908 1.91794C19.4802 1.69995 18.9201 1.69995 17.8 1.69995H4.2C3.0799 1.69995 2.51984 1.69995 2.09202 1.91794C1.7157 2.10968 1.40973 2.41565 1.21799 2.79197C1 3.21979 1 3.77985 1 4.89995V12.4999C1 13.6201 1 14.1801 1.21799 14.6079C1.40973 14.9843 1.71569 15.2902 2.09202 15.482C2.51984 15.6999 3.0799 15.6999 4.2 15.6999H11",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletService);
export default __webpack_public_path__ + "static/media/walletService.af178f1a08f203e82438d28881d71714.svg";
export { ForwardRef as ReactComponent };